var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import downloadCsv from "@irati/utils/downloadCsv";
import Icon from "@irati/ui/src/Icon";
import { perkbox } from "@irati/ui/src/global/colors";
import Flex from "@irati/ui/src/Flex";
import { DownloadCsvText } from "./styled";
var DownloadCsvTemplate = /** @class */ (function (_super) {
    __extends(DownloadCsvTemplate, _super);
    function DownloadCsvTemplate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.downloadCsv = function () {
            var formatMessage = _this.props.formatMessage;
            var headers = [
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.firstName.label" }),
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.lastName.label" }),
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.email.label" }),
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.team.label" }),
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.role.label" }),
                formatMessage({ id: "admin.components.addPeopleCSV.fieldsMapping.externalId.label" })
            ].join(",");
            // \ufeff needed to specify the csv may contain utf-8 characters
            var csv = "\uFEFF" + headers + "\n" + formatMessage({ id: "admin.components.addPeopleCSV.downloadCsvTemplate.csv" });
            var fileName = formatMessage({ id: "admin.components.addPeopleCSV.downloadCsvTemplate.fileName" });
            downloadCsv(csv, fileName);
        };
        return _this;
    }
    DownloadCsvTemplate.prototype.render = function () {
        return (React.createElement(DownloadCsvText, { onClick: this.downloadCsv },
            React.createElement(Flex, { alignItems: "center" },
                React.createElement(Icon, { icon: "fileDownload", color: perkbox.blue, margin: "0 5px 0 0" }),
                React.createElement(FormattedMessage, { id: "admin.components.addPeopleCSV.downloadCsvTemplate.text" }))));
    };
    return DownloadCsvTemplate;
}(Component));
export default injectIntl(DownloadCsvTemplate);
